module.exports = __webpack_public_path__ + "static/media/header_gacha3520034e52b7c6860e1d3cc43a441342.webp";